// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1412": "03a31bbf2b6b","7424": "bfd23840dd44","7802": "430ce9d7a079",}[chunkId] + ".css"
}